import { styled } from '@mui/material/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Box,
  Typography,
  Button,
} from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => `
  .MuiDialog-paper {
    background-color: var(--sevv-bg-paper, #ffffff);
    color: var(--sevv-text-primary, #424242);
    min-width: 500px;
    max-width: 600px;
    border-radius: 16px;
    border: 1px solid var(--sevv-divider, #eeeeee);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    overflow: hidden;
  }

  .MuiDialogTitle-root {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--sevv-bg-default, #fafafa);
    padding: 16px 24px;
    border-bottom: 1px solid var(--sevv-divider, #eeeeee);
  }
  
  .dialog-title-text {
    font-size: 18px;
    font-weight: 700;
    color: var(--sevv-text-primary, #424242);
    font-family: var(--sevv-font-family, 'Lato', 'Roboto', sans-serif);
  }

  .MuiDialogContent-root {
    padding: 24px;
    background: var(--sevv-bg-paper, #ffffff);
  }

  .MuiDialogActions-root {
    padding: 16px 24px;
    background-color: var(--sevv-bg-default, #fafafa);
    border-top: 1px solid var(--sevv-divider, #eeeeee);
  }

  .MuiTab-root {
    color: var(--sevv-text-secondary, #757575);
    text-transform: none;
    font-weight: 600;
    font-size: 14px;
    min-width: 100px;
    
    &.Mui-selected {
      color: var(--sevv-primary, #f97415);
    }
  }
  
  .MuiTabs-indicator {
    background-color: var(--sevv-primary, #f97415);
    height: 3px;
    border-radius: 3px 3px 0 0;
  }

  .MuiTextField-root {
    margin-bottom: 16px;
    .MuiOutlinedInput-root {
      color: var(--sevv-text-primary, #424242);
      border-radius: 8px;
      background: var(--sevv-bg-paper, #ffffff);
      
      fieldset {
        border-color: var(--sevv-divider, #eeeeee);
        transition: border-color 0.2s;
      }
      &:hover fieldset {
        border-color: color-mix(in srgb, var(--sevv-primary, #f97415) 35%, transparent);
      }
      &.Mui-focused fieldset {
        border-color: var(--sevv-primary, #f97415);
      }
    }
    .MuiInputLabel-root {
      color: var(--sevv-text-secondary, #757575);
      &.Mui-focused {
        color: var(--sevv-primary, #f97415);
      }
    }
    .MuiFormHelperText-root {
      margin-top: 4px;
      font-size: 12px;
      
      &.Mui-error {
        color: var(--sevv-error, #e74c3c);
      }
    }
  }
`);

export const AvatarGrid = styled(Grid)(({ theme }) => `
  margin-top: 16px;
  
  .avatar-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
    border: 2px solid transparent;
    background-color: var(--sevv-bg-default, #fafafa);
    
    &:hover {
      background-color: color-mix(in srgb, var(--sevv-primary, #f97415) 8%, transparent);
    }
    
    &.selected {
      border-color: var(--sevv-primary, #f97415);
      background-color: color-mix(in srgb, var(--sevv-primary, #f97415) 10%, transparent);
    }
    
    .avatar-label {
      font-size: 12px;
      text-transform: capitalize;
      color: var(--sevv-text-primary, #424242);
    }
  }
`);

export const CharacterSelectionWrapper = styled(Box)(({ theme }) => `
  padding: 0 10px;
`);

export const CharacterSelectionHeader = styled(Box)(({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`);

export const CharacterGrid = styled(Grid)(({ theme }) => `
  .character-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    padding: 8px;
    border-radius: 8px;
    transition: all 0.2s ease;
    &:hover {
      background-color: color-mix(in srgb, var(--sevv-primary, #f97415) 8%, transparent);
      transform: translateY(-2px);
    }
    &.selected {
      background-color: color-mix(in srgb, var(--sevv-primary, #f97415) 15%, transparent);
      border: 2px solid var(--sevv-primary, #f97415);
    }
  }
  .character-label {
    margin-top: 6px;
    font-size: 13px;
    color: var(--sevv-text-primary, #424242);
    font-weight: 500;
  }
  .character-image-container {
    width: 90px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--sevv-gray-100, #f5f5f5);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
  }
  .character-image {
    width: 65px;
    height: 95px;
    object-fit: contain;
  }
`);

export const NameDisplayPreview = styled(Box)(({ theme }) => `
  background: var(--sevv-bg-default, #fafafa);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  border: 1px solid var(--sevv-divider, #eeeeee);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`);

export const NamePreviewTitle = styled(Typography)(({ theme }) => `
  font-size: 12px;
  color: var(--sevv-text-secondary, #757575);
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
`);

export const NameDisplay = styled('div')(({ theme }) => `
  font-size: 18px;
  font-weight: 600;
  color: var(--sevv-text-primary, #424242);
  display: flex;
  align-items: center;
  gap: 12px;
`);

export const UploadButton = styled(Button)(({ theme }) => `
  margin-top: 16px;
  text-transform: none;
  font-weight: 600;
  color: var(--sevv-primary, #f97415);
  border-color: var(--sevv-primary, #f97415);
  background-color: transparent;
  padding: 8px 16px;
  border-radius: 8px;
  
  &:hover {
    background-color: color-mix(in srgb, var(--sevv-primary, #f97415) 8%, transparent);
    border-color: var(--sevv-primary-dark, #d65c05);
    color: var(--sevv-primary-dark, #d65c05);
  }
  
  &.Mui-disabled {
    color: var(--sevv-gray-400, #bdbdbd);
    border-color: var(--sevv-gray-200, #e0e0e0);
  }
`);

export const CustomAvatarBox = styled(Box)(({ theme }) => `
  margin-top: 16px;
  padding: 20px;
  border-radius: 8px;
  background-color: var(--sevv-bg-default, #fafafa);
  border: 1px solid var(--sevv-divider, #eeeeee);
  display: flex;
  flex-direction: column;
  align-items: center;
`);

export const AvatarPreview = styled(Box)(({ theme }) => `
  width: 100px;
  height: 100px;
  margin: 16px auto;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid var(--sevv-divider, #eeeeee);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`);

export const UploadInput = styled('input')(({ theme }) => `
  display: none;
`);

export const SaveButton = styled(Button)(({ theme }) => `
  background: linear-gradient(135deg, var(--sevv-primary, #f97415) 0%, var(--sevv-primary-light, #ffa047) 100%);
  color: var(--sevv-white, #ffffff) !important;
  font-weight: 600;
  text-transform: none;
  padding: 8px 24px;
  border-radius: 8px;
  box-shadow: var(--sevv-shadow-primary, 0 4px 14px 0 rgba(249, 116, 21, 0.3));
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: linear-gradient(135deg, var(--sevv-primary-dark, #d65c05) 0%, var(--sevv-primary, #f97415) 100%);
    box-shadow: var(--sevv-shadow-primary-lg, 0 6px 20px 0 rgba(249, 116, 21, 0.4));
    transform: translateY(-1px);
    color: var(--sevv-white, #ffffff) !important;
  }

  &:active {
    transform: translateY(0);
  }

  &.Mui-disabled {
    background: var(--sevv-gray-200, #e0e0e0);
    color: var(--sevv-gray-600, #9e9e9e) !important;
    box-shadow: none;
  }
`);

export const CancelButton = styled(Button)(({ theme }) => `
  color: var(--sevv-text-secondary, #757575);
  border-color: var(--sevv-divider, #eeeeee);
  text-transform: none;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;

  &:hover {
    background-color: var(--sevv-bg-default, #fafafa);
    border-color: var(--sevv-gray-200, #e0e0e0);
  }
`);

export const ErrorMessage = styled(Box)(({ theme }) => `
  margin-bottom: 16px;
  padding: 12px;
  background-color: color-mix(in srgb, var(--sevv-error, #e74c3c) 10%, transparent);
  border: 1px solid color-mix(in srgb, var(--sevv-error, #e74c3c) 30%, transparent);
  border-radius: 8px;
  color: var(--sevv-error, #e74c3c);
`);

export const SuccessMessage = styled(Box)(({ theme }) => `
  margin-bottom: 16px;
  padding: 12px;
  background-color: color-mix(in srgb, var(--sevv-success, #27ae60) 10%, transparent);
  border: 1px solid color-mix(in srgb, var(--sevv-success, #27ae60) 30%, transparent);
  border-radius: 8px;
  color: var(--sevv-success, #27ae60);
`); 